import { gql } from "@apollo/client";
import { PERSON_FIELDS_FRAGMENT } from "../../../common/fieldsFragment";

export const GET_PERSON = gql`
  query GetPerson($personId: String!) {
    QR_GET_PERSON(personId: $personId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        ...PersonFields
      }
    }
  }
  ${PERSON_FIELDS_FRAGMENT}
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdatePerson($personId: String!, $personInput: PersonInput!) {
    MT_UPDATE_PERSON(personId: $personId, personInput: $personInput) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        ...PersonFields
      }
    }
  }
  ${PERSON_FIELDS_FRAGMENT}
`;

export const updatePerson = async (
  updatePersonMutation,
  personId,
  personInput
) => {
  try {
    // const accessToken = Cookies.get("ZORNI_AUTH_TOKEN");
    // const bearerToken =accessToken ? 'Bearer '.accessToken : null;
    const { loading, error, data } = await updatePersonMutation({
      variables: {
        personId,
        personInput,
      },
      // context: {
      //   headers: {
      //     authorization: accessToken,
      //   },
      // },
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Error creating user:", error.message);
    throw error;
  }
};
